<div class="wrapper">
  <div class="header">
    <span
      class="backBtn clickable"
      (click)="onClose()"
      i18n="@@general.documents"
      ><img src="assets/Keen&Wise_back.png" /> Documents</span
    >
  </div>
  <div class="body">
    <div class="preview-container">
      <app-document-viewer [pdf]="pdf"></app-document-viewer>
    </div>
    <div *ngIf="!rejectionReasonVisible"></div>
    <div class="card" *ngIf="rejectionReasonVisible">
      <span class="card-title" i18n="@@document.list.signed.preview.reason"
        >Reason for rejection</span
      >
      <span>{{ item.signedRemarks }}</span>
    </div>
    <div class="buttons">
      <button
        *ngIf="printVisible"
        class="printBtn button customBtn"
        (click)="onPrint()"
      >
        <img class="btnImg" src="assets/Print.svg" />
        <span class="btnText" i18n="@@general.print">print</span>
      </button>

      <button
        *ngIf="backToPendingVisible"
        class="back-to-pending button customBtn"
        (click)="onBackToPending()"
      >
        <div class="masked-button">
          <div class="mask"></div>
        </div>
        <span
          class="btnText"
          i18n="@@document.list.rejection.signed.backtopending"
          >set back to pending</span
        >
      </button>
      <button
        *ngIf="uploadNewVisible"
        class="upload-new button customBtn"
        (click)="onUploadNew()"
      >
        <div class="masked-button">
          <div class="mask"></div>
        </div>
        <span class="btnText" i18n="@@document.list.rejection.signed.uploadnew"
          >upload new</span
        >
      </button>
    </div>
  </div>
</div>
